import { render, staticRenderFns } from "./BatchDetailDialog.vue?vue&type=template&id=2aacb431&"
import script from "./BatchDetailDialog.vue?vue&type=script&lang=js&"
export * from "./BatchDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports